var _g, _path, _g2, _g3, _g4, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMapboxStream(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 54,
    viewBox: "0 0 52 54",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_6736_83479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2979 12.7856C6.2694 19.8141 6.26937 31.2096 13.2978 38.238C20.3263 45.2665 31.7218 45.2665 38.7503 38.238C45.7788 31.2095 45.7789 19.814 38.7504 12.7855C31.7219 5.75704 20.3264 5.75707 13.2979 12.7856Z",
    fill: "url(#paint0_linear_6736_83479)",
    stroke: "#363636",
    strokeWidth: 2,
    strokeMiterlimit: 10
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.234,
    d: "M13.2979 12.7856C16.2357 9.85141 20.0975 8.02291 24.2291 7.6099C28.3606 7.19689 32.5079 8.22475 35.9684 10.5194C39.4289 12.814 41.9898 16.2343 43.2173 20.2008C44.4448 24.1674 44.2634 28.4363 42.7039 32.2844C40.9076 36.7082 37.4277 40.2372 33.0295 42.0952C28.6313 43.9531 23.6752 43.9878 19.2514 42.1916C14.8277 40.3954 11.2987 36.9154 9.44076 32.5173C7.58283 28.1191 7.54817 23.163 9.34439 18.7392C10.2483 16.5089 11.593 14.484 13.2979 12.7856ZM38.3528 37.8404C41.1954 34.9945 42.9668 31.2534 43.367 27.2509C43.7672 23.2484 42.7714 19.2306 40.5485 15.8782C38.3256 12.5258 35.0121 10.0449 31.1695 8.85579C27.3268 7.66667 23.1912 7.84245 19.4633 9.35335C15.1829 11.097 11.7698 14.4684 9.97361 18.727C8.17744 22.9856 8.1452 27.783 9.88395 32.0653C11.6227 36.3476 14.9902 39.7646 19.2468 41.5656C23.5033 43.3665 28.3007 43.4042 32.585 41.6703C34.7457 40.7947 36.7074 39.4921 38.3528 37.8404Z",
    fill: "url(#paint1_linear_6736_83479)"
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4904 13.9785C8.12076 20.3482 8.12073 30.6754 14.4904 37.0451C20.86 43.4147 31.1872 43.4147 37.5569 37.045C43.9266 30.6754 43.9266 20.3481 37.557 13.9785C31.1873 7.60884 20.8601 7.60887 14.4904 13.9785Z",
    fill: "url(#paint2_linear_6736_83479)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_6736_83479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.6843 15.1717C9.97364 20.8824 9.97362 30.1412 15.6843 35.8519C21.3949 41.5625 30.6537 41.5625 36.3644 35.8518C42.0751 30.1411 42.0751 20.8823 36.3644 15.1717C30.6538 9.46104 21.395 9.46107 15.6843 15.1717Z",
    fill: "#A3AAB7"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M15.6843 15.1717C9.97364 20.8824 9.97362 30.1412 15.6843 35.8519C21.3949 41.5625 30.6537 41.5625 36.3644 35.8518C42.0751 30.1411 42.0751 20.8823 36.3644 15.1717C30.6538 9.46104 21.395 9.46107 15.6843 15.1717Z",
    fill: "url(#paint3_radial_6736_83479)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M15.6843 15.1717C9.97364 20.8824 9.97362 30.1412 15.6843 35.8519C21.3949 41.5625 30.6537 41.5625 36.3644 35.8518C42.0751 30.1411 42.0751 20.8823 36.3644 15.1717C30.6538 9.46104 21.395 9.46107 15.6843 15.1717Z",
    fill: "url(#paint4_radial_6736_83479)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.4,
    d: "M15.6841 15.1714C18.0711 12.7875 21.2088 11.3019 24.5656 10.9664C27.9225 10.6309 31.2921 11.466 34.1037 13.3304C36.9153 15.1947 38.996 17.9736 39.9934 21.1964C40.9908 24.4191 40.8435 27.8876 39.5765 31.0142C38.1129 34.6026 35.2852 37.4635 31.7141 38.9688C28.143 40.474 24.1205 40.5006 20.5299 39.0427C16.9392 37.5847 14.0739 34.7615 12.5631 31.1927C11.0522 27.624 11.0194 23.6016 12.4717 20.0086C13.2061 18.1965 14.2987 16.5513 15.6841 15.1714ZM35.5688 35.0561C37.7698 32.8528 39.1415 29.9565 39.4515 26.8577C39.7615 23.7589 38.9908 20.6482 37.2698 18.0526C35.5489 15.457 32.9836 13.5362 30.0085 12.6154C27.0335 11.6947 23.8316 11.8308 20.9454 13.0005C17.6274 14.3476 14.9804 16.9575 13.5868 20.2562C12.1931 23.5549 12.1669 27.272 13.514 30.59C14.861 33.908 17.4709 36.5549 20.7696 37.9485C24.0682 39.3422 27.7854 39.3684 31.1034 38.0213C32.7762 37.3434 34.295 36.3348 35.5688 35.0561Z",
    fill: "url(#paint5_linear_6736_83479)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M15.6839 15.172C13.2678 17.5881 13.0007 21.2383 15.0873 23.3249C17.1739 25.4115 20.8241 25.1444 23.2402 22.7283C25.6563 20.3122 25.9235 16.662 23.8368 14.5754C21.7502 12.4887 18.1 12.7559 15.6839 15.172Z",
    fill: "url(#paint6_linear_6736_83479)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M15.6844 15.1721C11.2916 19.5649 10.9355 26.331 14.889 30.2845C18.8425 34.238 25.6086 33.8819 30.0014 29.4891C34.3942 25.0962 34.7504 18.3302 30.7968 14.3767C26.8433 10.4231 20.0773 10.7793 15.6844 15.1721Z",
    fill: "url(#paint7_linear_6736_83479)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3,
    d: "M20.8544 20.3422C21.956 19.2417 23.4042 18.5559 24.9536 18.4009C26.503 18.2459 28.0583 18.6312 29.3561 19.4917C30.6539 20.3522 31.6143 21.6348 32.0747 23.1224C32.535 24.6099 32.467 26.2108 31.8821 27.6539C31.2087 29.313 29.9038 30.6365 28.2545 31.3334C26.6051 32.0303 24.7466 32.0435 23.0875 31.37C21.4285 30.6966 20.105 29.3917 19.4081 27.7424C18.7112 26.0931 18.698 24.2345 19.3715 22.5754C19.7105 21.7388 20.2148 20.9793 20.8544 20.3422ZM30.0014 29.4893C30.866 28.624 31.4547 27.5217 31.6931 26.3219C31.9314 25.1221 31.8087 23.8786 31.3405 22.7485C30.8724 21.6184 30.0797 20.6524 29.0627 19.9727C28.0456 19.293 26.85 18.93 25.6267 18.9296C24.8016 18.9091 23.9806 19.0539 23.2123 19.3555C22.444 19.6571 21.7438 20.1094 21.1529 20.6858C20.5621 21.2622 20.0925 21.9509 19.7719 22.7115C19.4513 23.4721 19.2861 24.2892 19.2861 25.1146C19.2861 25.94 19.4513 26.757 19.7719 27.5176C20.0925 28.2782 20.562 28.967 21.1529 29.5434C21.7437 30.1197 22.444 30.572 23.2123 30.8736C23.9806 31.1752 24.8015 31.32 25.6267 31.2995C26.4393 31.302 27.2444 31.1432 27.9953 30.8325C28.7463 30.5218 29.4281 30.0653 30.0014 29.4893Z",
    fill: "url(#paint8_linear_6736_83479)"
  }), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_d_6736_83479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.6738 17.1601C13.0612 21.7726 13.0612 29.251 17.6737 33.8635C22.2862 38.476 29.7646 38.476 34.3771 33.8635C38.9897 29.2509 38.9897 21.7725 34.3772 17.16C29.7647 12.5475 22.2863 12.5475 17.6738 17.1601Z",
    fill: "black",
    fillOpacity: 0.4
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter3_d_6736_83479)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21.2536 20.7366C18.8375 23.1527 18.8375 27.07 21.2536 29.4861C23.6697 31.9022 27.587 31.9022 30.0032 29.4861C32.4193 27.07 32.4193 23.1527 30.0032 20.7366C27.5871 18.3205 23.6698 18.3205 21.2536 20.7366Z",
    fill: "black",
    fillOpacity: 0.2
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.6378 23.1247C22.5396 24.223 22.5396 26.0036 23.6378 27.1019C24.7361 28.2002 26.5168 28.2002 27.615 27.1019C28.7133 26.0036 28.7133 24.223 27.615 23.1247C26.5168 22.0264 24.7361 22.0264 23.6378 23.1247Z",
    fill: "#373737",
    fillOpacity: 0.8
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    d: "M25.2286 24.717C24.5696 25.376 24.5696 26.4444 25.2286 27.1034C25.8876 27.7624 26.956 27.7624 27.615 27.1034C28.274 26.4444 28.274 25.3759 27.615 24.7169C26.956 24.058 25.8876 24.058 25.2286 24.717Z",
    fill: "url(#paint9_linear_6736_83479)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "soft-light"
    },
    d: "M24.0357 23.523C23.5964 23.9623 23.5964 24.6745 24.0357 25.1138C24.475 25.553 25.1872 25.553 25.6265 25.1138C26.0658 24.6745 26.0658 23.9623 25.6265 23.523C25.1872 23.0837 24.475 23.0837 24.0357 23.523Z",
    fill: "url(#paint10_linear_6736_83479)"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.5,
    d: "M22.0474 21.5348C26.1664 17.4159 30.9927 14.8645 35.2682 14.1773C35.65 14.4903 36.0158 14.8221 36.3644 15.1717C39.1068 17.914 40.6474 21.6335 40.6474 25.5117C40.6474 29.39 39.1067 33.1095 36.3644 35.8518C33.622 38.5942 29.9026 40.1348 26.0243 40.1348C22.146 40.1348 18.4266 38.5942 15.6843 35.8519C15.3347 35.5033 15.0028 35.1374 14.6898 34.7556C15.3773 30.4799 17.9284 25.6538 22.0474 21.5348Z",
    fill: "url(#paint11_radial_6736_83479)"
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M25.6265 25.1148C25.1872 25.5541 25.1872 26.2663 25.6265 26.7056C26.0658 27.1448 26.778 27.1448 27.2173 26.7055C27.6566 26.2663 27.6566 25.554 27.2173 25.1148C26.778 24.6755 26.0658 24.6755 25.6265 25.1148Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_6736_83479",
    x: 2.02649,
    y: 3.51367,
    width: 47.9952,
    height: 47.9961,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 2
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.694 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6736_83479"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6736_83479",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_6736_83479",
    x: 8.40125,
    y: 10.8887,
    width: 35.2462,
    height: 35.2461,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.502 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6736_83479"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6736_83479",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_d_6736_83479",
    x: 1.21436,
    y: 3.70117,
    width: 49.6222,
    height: 49.6211,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.235 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6736_83479"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6736_83479",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_d_6736_83479",
    x: 6.44153,
    y: 8.92383,
    width: 38.3738,
    height: 38.375,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 3
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 6.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.235 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_6736_83479"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_6736_83479",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_6736_83479",
    x1: 13.2979,
    y1: 12.7856,
    x2: 38.7503,
    y2: 38.238,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4B4E54"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#555353"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_6736_83479",
    x1: 38.7498,
    y1: 38.2452,
    x2: 13.294,
    y2: 12.7895,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_6736_83479",
    x1: 14.4904,
    y1: 13.9785,
    x2: 31.0752,
    y2: 30.5633,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.875
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.529
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_6736_83479",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(39.6319 28.2002) rotate(135) scale(33.7793)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C2AFAF",
    stopOpacity: 0.502
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0.502
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_6736_83479",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.6843 15.1717) rotate(135) scale(12.6636)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.698
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_6736_83479",
    x1: 39.9381,
    y1: 26.8946,
    x2: 11.6784,
    y2: 23.2025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_6736_83479",
    x1: 16.4849,
    y1: 15.973,
    x2: 23.2402,
    y2: 22.7283,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.369
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_6736_83479",
    x1: 17.202,
    y1: 16.6897,
    x2: 24.4894,
    y2: 23.977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.451
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_6736_83479",
    x1: 30.3993,
    y1: 29.8897,
    x2: 20.8531,
    y2: 20.3435,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_6736_83479",
    x1: 27.615,
    y1: 27.1034,
    x2: 25.2286,
    y2: 24.717,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_6736_83479",
    x1: 24.8311,
    y1: 22.7276,
    x2: 24.8311,
    y2: 25.9091,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint11_radial_6736_83479",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(26.0705 25.5579) rotate(135) scale(27.9886 19.3766)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapboxStream);
export default __webpack_public_path__ + "static/media/mapbox_stream.34c82b65151c2cff1c8e56c7bb6fa3b5.svg";
export { ForwardRef as ReactComponent };